const LoginFooter = () => (
  <div className="Login__Footer">
    Made with &nbsp;
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="14"
      viewBox="0 0 12 16"
      fill="rgb(101, 119, 134)"
    >
      <path
        fillRule="evenodd"
        d="M11.2 3c-.52-.63-1.25-.95-2.2-1-.97 0-1.69.42-2.2 1-.51.58-.78.92-.8 1-.02-.08-.28-.42-.8-1-.52-.58-1.17-1-2.2-1-.95.05-1.69.38-2.2 1-.52.61-.78 1.28-.8 2 0 .52.09 1.52.67 2.67C1.25 8.82 3.01 10.61 6 13c2.98-2.39 4.77-4.17 5.34-5.33C11.91 6.51 12 5.5 12 5c-.02-.72-.28-1.39-.8-2.02V3z"
      />
    </svg>
    &nbsp; by the frontend team. Spotahome 2018
  </div>
);

export default LoginFooter;
